<app-top-navigation [openLoginWindow]="isLoginOpen"></app-top-navigation>
<ng-container *ngIf="monumentsMetaCheckboxes$ | async as metaData">
	<div class="buyPage" *ngIf="siteSelected$ | async as siteDto">
		<div class="stepContainer">
			<ul>
				<li [class.active]="activeStep >= 1">
					<div class="arrow-right" *ngIf="activeStep === 1"></div>
					<div class="step-header-container">
						<span>1</span> {{"TRANS_REMOTE_BUY.TRANS_REMOTE_BILLING" | translate}}
					</div>
				</li>
				<li [class.active]="activeStep >= 2">
					<div class="arrow-right" *ngIf="activeStep === 2"></div>
					<div class="step-header-container">
						<span>2</span> {{"TRANS_REMOTE_BUY.TRANS_REMOTE_PAYMENT" | translate}}
					</div>
				</li>
				<li [class.active]="activeStep >= 3">
					<div class="step-header-container">
						<span>3</span> {{"TRANS_REMOTE_BUY.TRANS_REMOTE_CHECKOUT" | translate}}
					</div>
				</li>
			</ul>
		</div>
		<div class="processContainer">
			<div class="row">
				<div class="col-md-8">
					<div class="step text-center" style="margin-top: 100px" *ngIf="flowLoading">
						<div class="loader-block">
							<svg id="loader2" viewBox="0 0 100 100">
								<circle id="circle-loader2" cx="50" cy="50" r="45"></circle>
							</svg>
						</div>
						<div>LOADING....</div>
					</div>
					<div class="step step-1" [hidden]="activeStep != 1">
						<form [formGroup]="userForm">
							<app-user-basic-info style="display: block" formControlName="basicInfo" [readonlyOnValid]="true"></app-user-basic-info>
							<app-user-billing-info formControlName="billingInfo" style="display: block"
												   class="mt-3"></app-user-billing-info>
						</form>
						<button class="next-button btn btn-primary" (click)="goBilling()"
								[disabled]="userForm.invalid">{{"TRANS_REMOTE_BUY.TRANS_REMOTE_PAYMENT" | translate}}
							<fa-icon [icon]="['fas','chevron-right']"></fa-icon>
						</button>
					</div>
					<div class="step step-2" [hidden]="activeStep != 2">
						<div id="pay-form"></div>
						<div class="payment-explanation" style="padding: 0 25px">
							<sup>*</sup>{{"TRANS_REMOTE_BUY.TRANS_REMOTE_CARD_INFO" | translate}}
						</div>
						<div style="padding: 0 25px;">
							<input type="checkbox" #acceptTerms
								   (click)="checkTerms(acceptTerms)" /> {{"TRANS_REMOTE_BUY.TRANS_REMOTE_ACCEPT" | translate}}
							<app-terms-policy>
								{{"TRANS_REMOTE_BUY.TRANS_REMOTE_AND" | translate}}
							</app-terms-policy>
							<div class="text-danger" *ngIf="acceptError">
								{{"TRANS_REMOTE_BUY.TRANS_TERMS_ERROR" | translate}}
							</div>
						</div>
						<button class="next-button btn btn-primary" *ngIf="!flowLoading" (click)="payButton(acceptTerms)">Buy now {{packet.price}}&euro;
							<fa-icon [icon]="['fas','chevron-right']"></fa-icon>
						</button>
					</div>
					<div class="step step-3" *ngIf="activeStep ===3">
						<div class="processCompleted">
							<fa-icon [icon]="['fas','check-circle']"></fa-icon>
							<p class="text-center">
								{{"TRANS_REMOTE_BUY.TRANS_COMPLETE_ORDER" | translate}}
							</p>
							<p class="subtitle">
								{{"TRANS_REMOTE_BUY.TRANS_EMAIL_NOTICE" | translate}}
							</p>
						</div>
						<div>
							<h6 class="text-center">{{"TRANS_REMOTE_BUY.TRANS_SUMMARY" | translate}}:</h6>
							<div class="row text-right" style="padding: 14px 104px;">
								<div class="font-weight-bold col-md-3">{{"TRANS_REMOTE_BUY.TRANS_PRODUCT" | translate}}:</div>
								<div class="col-md-9" *ngIf="packetsId.length ===1">
									{{this.globalDataService.getObjectTranslation(siteDto.siteTranslations, "name")}}
									{{this.globalDataService.getObjectTranslation(packet.packetTranslations, "name")}}
								</div>
								<div class="col-md-9" *ngIf="packetsId.length >1">
									<ul *ngIf="siteDto">
										<li *ngFor="let site of siteDto" style="display: inline-block; margin-right: 4px;">
											{{this.globalDataService.getObjectTranslation(site.siteTranslations, "name")}}
										</li>
									</ul>
								</div>
								<div class="font-weight-bold col-md-3">{{"TRANS_REMOTE_BUY.TRANS_PRICE" | translate}}:</div>
								<div class="col-md-9">{{packet.price}}&euro;</div>
								<div class="font-weight-bold col-md-3">{{"TRANS_REMOTE_BUY.TRANS_NAME" | translate}}:</div>
								<div class="col-md-9">{{currentUser.name}}</div>
								<div class="font-weight-bold col-md-3">{{"TRANS_REMOTE_BUY.TRANS_LAST_NAME" | translate}}:</div>
								<div class="col-md-9">{{currentUser.lastName}}</div>
								<div class="font-weight-bold col-md-3">Email:</div>
								<div class="col-md-9">{{currentUser.email}}</div>
							</div>
							<div class="row justify-content-center">
								<a
										[routerLink]="[this.globalDataService.getRemoteContext()+'/'+this.globalDataService.getCurrentLang()+'/profile/order']"
										class="btn btn-primary">{{"TRANS_REMOTE_BUY.TRANS_VIEW_ORDERS" | translate}}</a>&nbsp;&nbsp;
								<a *ngIf="packetsId.length ===1"
										[routerLink]="[this.globalDataService.getRemoteContext()+'/'+this.globalDataService.getCurrentLang()+'/site/'+ siteDto.seotitle]"
										class="btn btn-primary">{{"TRANS_REMOTE_BUY.TRANS_TAKE_TOUR" | translate}}</a>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-4">
					<div class="separator"></div>
					<div class="packetContainer" style="margin-top: 50px;height: 52vh;">
						<ng-container *ngIf="packetsId.length ===1">
							<div class="siteName">{{this.globalDataService.getObjectTranslation(siteDto.siteTranslations, "name")}}</div>
							<div class="packetPrice">{{packet.price}}&euro;</div>
						</ng-container>
						<ng-container *ngIf="packetsId.length >1">
							<div style="text-align: center;">{{"TRANS_REMOTE_BUY.TRANS_MULTIPLE_SELECTED" | translate}}</div>
							<div class="multiNamesSites">
									<ul *ngIf="siteDto">
										<li *ngFor="let site of siteDto">
											{{this.globalDataService.getObjectTranslation(site.siteTranslations, "name")}}
										</li>
									</ul>
							</div>
							<div class="packetPrice">
								<span class="packetPriceDiscount">{{packet.price + packet.discount}}&euro;</span>
								{{packet.price}}&euro;
							</div>
						</ng-container>
						<div class="features">
							<ul *ngIf="monumentsMetaCheckboxes$ | async as metaData">
								<li>
									<fa-icon [icon]="['fas','check']"></fa-icon>
									{{metaData.length}} {{"TRANS_REMOTE_BUY.TRANS_MONUMENTS" | translate}}
								</li>
								<li>
									<fa-icon [icon]="['fas','check']"></fa-icon>
									{{metaData.panoramics}} {{"TRANS_REMOTE_BUY.TRANS_PANORAMIC" | translate}}
								</li>
								<li>
									<fa-icon [icon]="['fas','check']"></fa-icon>
									{{metaData.models}} 3D {{"TRANS_REMOTE_BUY.TRANS_MODELS" | translate}}
								</li>
								<li>
									<fa-icon [icon]="['fas','check']"></fa-icon>
									{{metaData.info}} {{"TRANS_REMOTE_BUY.TRANS_HISTORY" | translate}}
								</li>
								<li>
									<fa-icon [icon]="['fas','check']"></fa-icon>
									{{"TRANS_REMOTE_BUY.TRANS_FOR" | translate}} {{packet.effectiveDays}} {{"TRANS_REMOTE_BUY.TRANS_DAYS" | translate}}
								</li>
							</ul>
						</div>
						<div class="cardsContainer" style="text-align: center;width: 95%;">
							<img src="assets/images/cards/visa.png" style="width: 39px;margin-right: 11px;">
							<img src="assets/images/cards/mastercard.png" style="width: 41px;margin-right: 9px;">
							<img src="assets/images/cards/diners.png" style="margin-right: 10px;width: 92px;">
							<img src="assets/images/cards/discover.png" style="width: 52px;">
						</div>
						<div class="text-center" style="bottom: 3rem;width: 92%;position: absolute;">
							Powered By <br>
							<img src="assets/images/cards/everypay.png" style="width: 93px;">
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-container>